import { Component, Input } from '@angular/core'

import { ScopeElementsConfig } from '../models'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'

@Component({
  selector: 'scope-deliverable-sections-header',
  templateUrl: './deliverable-sections-header.component.html',
})
export class DeliverableSectionsHeaderComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number

  protected readonly isPreferenceActive = isPreferenceActive
}
